import { render, staticRenderFns } from "./mainFormOca.vue?vue&type=template&id=aabf285a&"
import script from "./mainFormOca.vue?vue&type=script&lang=js&"
export * from "./mainFormOca.vue?vue&type=script&lang=js&"
import style0 from "./mainFormOca.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports